export default "__VITE_ASSET__Cvdj4GLv__"